import { useCallback } from "react";

import { Module } from "types/generated";

import useCanManageModule from "./useCanManageModule";

const useCanEnableModule = (): ((module: Module) => boolean) => {
  const canManageModule = useCanManageModule();

  return useCallback(
    (module: Module) => {
      const isDisabled = module.isDisabled;

      return isDisabled && canManageModule(module);
    },
    [canManageModule]
  );
};

export default useCanEnableModule;
